import { OverlayRef } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  input,
  signal,
} from '@angular/core';
import { defer } from '@utils/runtime';
import { AbbCommonModule } from 'app/abb-common.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'abb-modal',
  standalone: true,
  imports: [AbbCommonModule, CommonModule],
  templateUrl: './abb-modal.component.html',
  host: {
    class: 'flex flex-1 min-h-0 flex-col',
  },
})
export class AbbModalComponent implements AfterViewInit, OnDestroy {
  title = input('');
  subtitle = input('');
  closable = input(true);
  backdropClickClosable = input(false);
  onBeforeClose = input<(() => Promise<boolean>) | undefined>();
  onDispose = input<() => void>();
  onClose = input<() => void>();
  open = signal(false);
  subscriptions: Subscription[] = [];
  constructor(protected overlayRef: OverlayRef) {
    if (this.backdropClickClosable()) {
      this.subscriptions.push(
        this.overlayRef.backdropClick().subscribe(() => {
          if (this.closable()) {
            this.handleClose();
          }
        })
      );
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
  ngAfterViewInit(): void {
    requestAnimationFrame(() => this.open.set(true));
  }
  async handleClose() {
    const onBeforeClose = this.onBeforeClose();
    if (onBeforeClose) {
      const canContinue = await onBeforeClose();
      if (!canContinue) {
        return;
      }
    }
    this.onClose()?.();
    this.dispose();
  }

  dispose() {
    this.open.set(false);
    setTimeout(() => {
      this.overlayRef.dispose();
      defer(() => this.onDispose()?.());
    }, 150);
  }
}
